(function(){
  document.addEventListener("DOMContentLoaded", function() {
    // Initialize default active items
    $('.collapsible-content__item.active .collapsible-content__answer').show();

    // Event delegation on document to handle dynamic or cloned elements
    $(document).on('click', '.collapsible-content__toggle', function(e) {
      e.preventDefault();
      var item = $(this).closest('.collapsible-content__item');
      var answer = item.find('.collapsible-content__answer');
      var isOpen = item.hasClass('active');
      
      // Remove CSS transition to avoid conflict with jQuery
      answer.css('transition', 'none');
      item.closest('.collapsible-content__items').find('.collapsible-content__answer').css('transition', 'none');
      
      if (isOpen) {
        item.removeClass('active');
        answer.stop().slideUp(300);
      } else {
        // Close others
        item.closest('.collapsible-content__items')
            .find('.collapsible-content__item')
            .not(item)
            .removeClass('active')
            .find('.collapsible-content__answer')
            .stop()
            .slideUp(300);
        
        item.addClass('active');
        answer.stop().slideDown(300);
      }
    });
  });

  const initCollapsibleContent = section => {
    // Restore the updateInfoSpacers functionality for Journal layout
    function updateInfoSpacers() {
      section.querySelectorAll(".collapsible-content__info").forEach(info => {
        const children = Array.from(info.children).filter(n => n.nodeType === 1);
        if (children.length >= 2) {
          const height = children[1].offsetHeight;
          info.style.setProperty("--spacer", height + "px");
        } else {
          info.style.removeProperty("--spacer");
        }
      });
    }
    
    updateInfoSpacers();
    let resizeTimer = null;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateInfoSpacers, 120);
    });
  };

  const startCollapsibleSlideshow=images=>{
    if(images.length>1){
      let speed=Number(images.closest(".collapsible-content__gallery").data("speed"))*1e3;
      var currentImageIndex=0;
      let fadeSpeed=1e3;
      images.eq(currentImageIndex).fadeIn(fadeSpeed);
      var interval=setInterval(function(){
        let nextImageIndex=(currentImageIndex+1)%images.length;
        images.eq(currentImageIndex).fadeOut(fadeSpeed),
        images.eq(nextImageIndex).fadeIn(fadeSpeed),
        currentImageIndex=nextImageIndex
      },speed)
    }
  };
  
  const initGallery=()=>{
    $(".collapsible-content").length>0&&$(".collapsible-content").each(function(index,item){
      var images=$(this).find(".collapsible-content__gallery--image-wrapper");
      startCollapsibleSlideshow(images)
    })
  };

  document.addEventListener("DOMContentLoaded",function(){
    document.querySelectorAll(".shopify-section").forEach(initCollapsibleContent);
    initGallery();
    
    document.addEventListener("shopify:section:load",function(event){
      initCollapsibleContent(event.target);
      initGallery();
    });
  });
})();
